import { render, staticRenderFns } from "./SurveyListPage.vue?vue&type=template&id=25d9d79a"
import script from "./SurveyListPage.vue?vue&type=script&lang=js"
export * from "./SurveyListPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyListPage.vue?vue&type=style&index=0&id=25d9d79a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports